module.exports = __webpack_public_path__ + "static/media/copyCheckout.40526c7c.svg";